import script from "./ActivationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivationView.vue?vue&type=script&setup=true&lang=js"

import "./ActivationView.vue?vue&type=style&index=0&id=2b9335b1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b9335b1"]])

export default __exports__